/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Legal_Footer_Verbis_StatusInputs */

const tr_legal_footer_verbis_status = /** @type {(inputs: Legal_Footer_Verbis_StatusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`VERBİS Başvuru No: 1779704748 · Onay sürecinde`)
};

const en_legal_footer_verbis_status = /** @type {(inputs: Legal_Footer_Verbis_StatusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`VERBİS application number: 1779704748 · approval pending`)
};

const de_legal_footer_verbis_status = /** @type {(inputs: Legal_Footer_Verbis_StatusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`VERBİS Antragsnummer: 1779704748 · im Genehmigungsverfahren`)
};

const ru_legal_footer_verbis_status = /** @type {(inputs: Legal_Footer_Verbis_StatusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Заявление VERBİS №: 1779704748 · на рассмотрении`)
};

/**
* | output |
* | --- |
* | "VERBİS application number: 1779704748 · approval pending" |
*
* @param {Legal_Footer_Verbis_StatusInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const legal_footer_verbis_status = /** @type {((inputs?: Legal_Footer_Verbis_StatusInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Legal_Footer_Verbis_StatusInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_legal_footer_verbis_status(inputs)
	if (locale === "de") return de_legal_footer_verbis_status(inputs)
	if (locale === "ru") return ru_legal_footer_verbis_status(inputs)
	return tr_legal_footer_verbis_status(inputs)
});